export default {
  TAMANHO_PAGINACAO: 15, // ALTERAR ANTES DE SUBIR
  URL_PORTAL_SEGURANCA: process.env.PORTAL_URL
}



// WEBPACK FOOTER //
// ./src/constants/configs.js